import { translate } from "app/language/service"
import { APP_CONTEXTS, NOT_SAVED_ID } from "app/model"
import { getStore } from "app/store/store"
import { isDateInThePast } from "app/util/date/tools/common"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { campaignRPO } from "campaign/repository"
import { isCampaignLaunchable } from "campaign/tools/common"
import { IForm } from "form/model"
import { formActionCreator } from "form/store/actions"
import { messageSVC } from "message/service"
import { getForm } from "./common"

export const isCampaignLaunchableInFormContext = (context: APP_CONTEXTS, status: CAMPAIGN_STATUSES): boolean =>
  context === APP_CONTEXTS.CAMPAIGN_EDIT && isCampaignLaunchable(status)

export function translatedLaunchError(form: IForm): string {
  if (form.context.appContext !== APP_CONTEXTS.CAMPAIGN_EDIT) {
    return translate("campaign.launch.error")
  }
  if (form.configuration.main.order_id === null || form.configuration.main.order_id === NOT_SAVED_ID) {
    return translate("campaign.launch.error.order.id")
  }
  if (form.configuration.main.advertiser_id === null || form.configuration.main.advertiser_id === NOT_SAVED_ID) {
    return translate("campaign.launch.error.advertiser.id")
  }
  if (!form.configuration.main.name || form.configuration.main.name === "") {
    return translate("campaign.launch.error.name")
  }
  if (form.configuration.budget.budget === null || form.configuration.budget.budget < 0) {
    return translate("campaign.launch.error.budget")
  }
  if (!form.configuration.main.unlimitedImpressions && form.configuration.main.max_views < 0) {
    return translate("campaign.launch.error.impression")
  }
  if (!(form.configuration.main.startDate instanceof Date)) {
    return translate("campaign.launch.error.start.date")
  }
  if (!(form.configuration.main.endDate instanceof Date)) {
    return translate("campaign.launch.error.end.date")
  }
  if (isDateInThePast(form.configuration.main.endDate)) {
    return translate("campaign.launch.error.end.date.expired")
  }
  if (form.creatives.medias.length === 0) {
    return translate("campaign.launch.error.media")
  }
  if (form.configuration.budget.max_bid === null || form.configuration.budget.max_bid < 1) {
    return translate("campaign.launch.error.max-bid")
  }
  return ""
}

export async function launchCampaign(): Promise<void> {
  const form = getForm()
  messageSVC.confirmMessage({
    title: translate("campaign.launch.title"),
    addGenericConfirmMessage: true,
    message: translate(form.context.isPaused ? "campaign.launch.confirm.paused" : "campaign.launch.confirm"),
    onSuccess: () => processLaunchingCampaign()
  })
}

async function processLaunchingCampaign(): Promise<void> {
  const form = getForm()
  const launchError = translatedLaunchError(form)
  if (launchError) {
    messageSVC.error(launchError)
    return
  }
  const overlayMessageId = messageSVC.displayWaitingOverlay(translate("campaign.launch.start"))
  try {
    // will set campaign status to review and send notifications
    const updatedCampaign = await campaignRPO.launchCampaign(form.campaignId)
    getStore().dispatch(
      formActionCreator.setForm({
        form: {
          ...form,
          statusId: updatedCampaign.status_id,
          context: {
            ...form.context,
            isPaused: false
          }
        }
      })
    )
    messageSVC.success(translate("campaign.launch.success"))
  } catch (error) {
    console.error(error)
    messageSVC.error(translate("campaign.launch.error"))
  }
  messageSVC.closeWaitingOverlay(overlayMessageId)
}
